const header = document.querySelector("[data-header]");
const heroFrame = document.querySelector("[data-hero-frame]");
const navPanels = [];

const formatMoney = (cents) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(cents / 100);

const closeNavPanel = (config) => {
  window.clearTimeout(config.closeTimer.current);
  config.popover.classList.remove("is-open");
  config.panel.classList.remove("is-open");
  config.nav?.classList.remove("is-panel-open");
  config.trigger.setAttribute("aria-expanded", "false");
};

const openNavPanel = (config) => {
  navPanels.forEach((item) => item !== config && closeNavPanel(item));
  window.clearTimeout(config.closeTimer.current);
  config.popover.classList.add("is-open");
  config.panel.classList.add("is-open");
  config.nav?.classList.add("is-panel-open");
  config.trigger.setAttribute("aria-expanded", "true");
};

const setupNavPanel = ({ popoverSelector, triggerSelector, panelSelector }) => {
  const popover = document.querySelector(popoverSelector);
  const trigger = document.querySelector(triggerSelector);
  const panel = document.querySelector(panelSelector);
  if (!popover || !trigger || !panel) return;

  const config = {
    popover,
    trigger,
    panel,
    nav: popover.closest(".pill-nav"),
    closeTimer: { current: null },
  };
  navPanels.push(config);

  const scheduleClose = () => {
    window.clearTimeout(config.closeTimer.current);
    config.closeTimer.current = window.setTimeout(() => closeNavPanel(config), 120);
  };

  popover.addEventListener("mouseenter", () => openNavPanel(config));
  popover.addEventListener("mouseleave", scheduleClose);
  panel.addEventListener("mouseenter", () => openNavPanel(config));
  panel.addEventListener("mouseleave", scheduleClose);
  trigger.addEventListener("click", (event) => {
    if (trigger.getAttribute("href")?.startsWith("#")) event.preventDefault();
    config.panel.classList.contains("is-open") ? closeNavPanel(config) : openNavPanel(config);
  });
};

setupNavPanel({
  popoverSelector: "[data-measure-popover]",
  triggerSelector: "[data-measure-trigger]",
  panelSelector: "[data-measure-panel]",
});
setupNavPanel({
  popoverSelector: "[data-color-popover]",
  triggerSelector: "[data-color-trigger]",
  panelSelector: "[data-color-panel]",
});
setupNavPanel({
  popoverSelector: "[data-reseller-popover]",
  triggerSelector: "[data-reseller-trigger]",
  panelSelector: "[data-reseller-panel]",
});

document.addEventListener("click", (event) => {
  navPanels.forEach((config) => {
    if (!config.popover.contains(event.target) && !config.panel.contains(event.target)) {
      closeNavPanel(config);
    }
  });
});

document.addEventListener("keydown", (event) => {
  if (event.key === "Escape") navPanels.forEach(closeNavPanel);
});

const updateScrollState = () => {
  if (!heroFrame) return;
  const heroBounds = heroFrame.parentElement.getBoundingClientRect();
  const progress = Math.min(1, Math.max(0, Math.abs(heroBounds.top) / (heroBounds.height - window.innerHeight)));
  heroFrame.classList.toggle("is-leaving", progress > 0.58);
  if (header) header.style.transform = progress > 0.9 ? "translateY(-130%)" : "translateY(0)";
};

let ticking = false;
const requestScrollUpdate = () => {
  if (ticking) return;
  window.requestAnimationFrame(() => {
    updateScrollState();
    ticking = false;
  });
  ticking = true;
};

window.addEventListener("scroll", requestScrollUpdate, { passive: true });
window.addEventListener("resize", requestScrollUpdate);
updateScrollState();

const revealSections = document.querySelectorAll(".reveal-section");
if ("IntersectionObserver" in window && revealSections.length) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.22 }
  );
  revealSections.forEach((section) => observer.observe(section));
} else {
  revealSections.forEach((section) => section.classList.add("is-visible"));
}

document.querySelector("[data-shopify-product-builder]")?.addEventListener("submit", async (event) => {
  event.preventDefault();
  const form = event.currentTarget;
  const items = [...form.querySelectorAll("[data-shopify-qty]")]
    .map((input) => ({
      id: Number(input.dataset.variantId),
      quantity: Math.max(0, Number.parseInt(input.value || "0", 10)),
    }))
    .filter((item) => item.quantity > 0);

  if (!items.length) return;

  const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ items }),
  });

  if (response.ok) {
    window.location.href = "/cart";
  }
});

const updateShopifyBuilder = (form) => {
  const inputs = [...form.querySelectorAll("[data-shopify-qty]")];
  const count = inputs.reduce((sum, input) => sum + Math.max(0, Number.parseInt(input.value || "0", 10)), 0);
  const total = inputs.reduce((sum, input) => sum + Math.max(0, Number.parseInt(input.value || "0", 10)) * Number(input.dataset.price || 0), 0);
  form.querySelector("[data-product-total]").textContent = formatMoney(total);
  form.querySelector("[data-product-count]").textContent = count === 1 ? "1 zaino" : `${count} zaini`;
};

document.querySelectorAll("[data-shopify-product-builder]").forEach((form) => {
  form.querySelectorAll("[data-shopify-qty]").forEach((input) => {
    input.addEventListener("input", () => updateShopifyBuilder(form));
    input.addEventListener("change", () => updateShopifyBuilder(form));
  });
  updateShopifyBuilder(form);
});
